// модальное окно на странице "Документы продаж"
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Layout,
  message,
  Modal,
  Popconfirm,
  Popover,
  Select,
  Table,
} from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import ContragentAutocomplete from "src/shared/api/ContragentAutocomplete";

import {
  CloseOutlined,
  DeleteOutlined,
  DollarOutlined,
  EditOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import SkeletonInput from "antd/es/skeleton/Input";
import Compact from "antd/es/space/Compact";
import axios from "axios";
import BarcodeReader from "react-barcode-reader";
import { DocsSalesOrderDrawer } from "src/enitities/Form";
import {
  ContragentTags,
  NomenclatureAutoComplete,
  OrganizationAutoComplete,
  WareHousesAutocomplete,
} from "src/shared";
import { apiRequests } from "src/shared/api/api";
import NomenclatureSearchField from "src/shared/api/NomenclatureSearchField";
import { AddBarCode } from "..";

const searchResult = async (api, token, query, ts) => {
  let type = ts ? "barcode" : "name";
  return fetch(`${api}nomenclature/?token=${token}&${type}=${query}`)
    .then((r) => r.json())
    .then((body) => body.result.map((u) => ({ label: u.name, value: u.id })));
};

const { Header, Sider, Content } = Layout;
const headerStyle  = { textAlign: "center", color: "#fff", height: 35, backgroundColor: "white", width: "100%", padding: "0" };
const contentStyle = { textAlign: "center", lineHeight: "120px", color: "#fff", backgroundColor: "white" };
const siderStyle   = { textAlign: "center", backgroundColor: "white" };

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({ title, editable, children, dataIndex, record, handleSave, ...restProps }) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);

  useEffect(() => { if (editing) inputRef.current.focus(); }, [editing]);

  const toggleEdit = () => { setEditing(!editing); form.setFieldsValue({ [dataIndex]: record[dataIndex] }); };

  const calculateSum = () => {
    const v = form.getFieldValue(dataIndex);
    form.setFieldValue(dataIndex, (Number(record.amount) * (Number(v) / 100)).toFixed(2));
  };

  const save = async () => {
    try { const values = await form.validateFields(); toggleEdit(); handleSave({ ...record, ...values }); }
    catch (e) { console.log("Save failed:", e); }
  };

  const handleBlur = (e) => {
    if (e.relatedTarget?.type === "button") { calculateSum(); save(); } else save();
  };

  let childNode = children;
  const ed = editing ? (
    <Form.Item style={{ margin: 0 }} name={dataIndex}
      rules={[{ required: dataIndex !== "amount" && dataIndex !== "weight", message: `${title} обязательно.` }]}>
      <Input ref={inputRef}
        addonAfter={dataIndex === "discount" ? <Button type="text" size="small" icon={<DollarOutlined />} /> : null}
        onPressEnter={save} onBlur={handleBlur} />
    </Form.Item>
  ) : (
    <div className="editable-cell-value-wrap" style={{ paddingRight: 24 }} onClick={toggleEdit}>{children}</div>
  );

  if (editable) {
    childNode = record.type !== "transfer" ? ed : (dataIndex === "tax" ? null : ed);
  }

  return <td {...restProps}>{childNode}</td>;
};

class EditDocsSales extends React.Component {
  constructor(props) {
    super(props);

    this.formRef         = React.createRef();
    this.formRefSettings = React.createRef();
    this.formRefNom      = React.createRef();
    this.finRef          = React.createRef();

    this.state = {
      current_contragent:       null,
      current_nomenclature:     null,
      changeData:               false,
      discount_type:            "percent",
      loyality_balance:         0,
      nomenclature_min:         0,
      nomenclature_max:         0,
      amount_without_discount:  0,
      amount_with_discount:     0,
      amount_discount:          0,
      nomDS:                    [],
      current_nomenclature_price: null,
      nomId:                    null,
      isRequestLoading:         false,
      isAddBarCodeVisible:      false,
      barcode:                  null,
      orgData:                  [],
      current_organization:     {},
      delivery_info:            {},
      price_types:              [],
      selected_price_type:      null,
      initialTags:              [],
    };
    this.api = `https://${process.env.REACT_APP_APP_URL}/api/v1/`;
    this.leftBarIV = { number: this.props.doc.number, comment: this.props.doc.comment };

    this.columns = [
      { title: "Название товара", key: "name",        dataIndex: "name" },
      { title: "Сумма",          key: "amount",       dataIndex: "amount",       editable: true },
      { title: "Скидка",         key: "discount",     dataIndex: "discount",     editable: true },
      { title: "Количество",     key: "count",        dataIndex: "count",        editable: true },
      {
        // ── Вес товара (граммы) — используется при формировании заказа СДЭК ──
        title:    "Вес (г)",
        key:      "weight",
        dataIndex: "weight",
        editable: true,
        width:    90,
        render:   (val) => val ? `${val} г` : "—",
      },
      { title: "Единица",        key: "unit",         dataIndex: "unit" },
      { title: "Итого",          key: "final_amount", dataIndex: "final_amount" },
      {
        title: "Действие", key: "action", dataIndex: "action",
        render: (_, record) => (
          <Popconfirm title="Подтвердите удаление" onConfirm={() => this.handleDeleteNom(record.id)} cancelText="Отмена" okText="OK">
            <Button icon={<DeleteOutlined />} style={{ marginRight: 10 }} />
          </Popconfirm>
        ),
      },
    ];
  }

  closeAddBarcode = () => this.setState({ isAddBarCodeVisible: false, barcode: null });

  barcodeFind = async (data) => {
    const res = await searchResult(this.api, this.props.token, data, true);
    if (!res[0]) this.setState({ isAddBarCodeVisible: true, barcode: data });
    else this.onSelectNom(res[0].value);
  };

  findDocSales = (id) =>
    fetch(`https://${process.env.REACT_APP_APP_URL}/api/v1/docs_sales/${id}/?token=${this.props.token}`)
      .then((r) => r.json());

  findContragent = (id) =>
    fetch(`https://${process.env.REACT_APP_APP_URL}/api/v1/contragents/${id}/?token=${this.props.token}`)
      .then((r) => r.json());

  raschet = (nomDS) => {
    let sw = 0, sd2 = 0, sd = 0;
    nomDS.forEach((item) => {
      sw  += parseFloat(item.final_amount);
      sd2 += parseFloat(item.discount);
      sd  += parseInt(item.count) * parseFloat(item.amount);
    });
    const total = parseFloat(sw).toFixed(2);
    this.setFinishPrices(total);
    this.setState({ amount_without_discount: parseFloat(sd).toFixed(2), amount_discount: parseFloat(sd2).toFixed(2), amount_with_discount: total });
  };

  handleSave = (row) => {
    const newData = [...this.state.nomDS];
    const index   = newData.findIndex((item) => row.id === item.id);
    const item    = newData[index];

    row.amount       = parseFloat(row.amount).toFixed(2);
    row.discount     = parseFloat(row.discount).toFixed(2);
    row.count        = parseFloat(row.count).toFixed(3);
    row.final_amount = parseFloat(row.amount * row.count).toFixed(2);
    if (row.discount > 0) row.final_amount = parseFloat(row.final_amount - row.discount).toFixed(2);
    // weight сохраняется как есть

    newData.splice(index, 1, { ...item, ...row });
    this.setState({ nomDS: newData }, () => this.raschet(newData));
  };

  onSelectCa = (val) => {
    if (!val) {
      this.formRef.current?.setFieldsValue({ contragent: null });
      return this.setState({ current_contragent: null });
    }
    this.findContragent(val).then((res) => {
      this.setState({ current_contragent: res });
      this.formRef.current?.setFieldsValue({ contragent: res.name });
      fetch(`https://${process.env.REACT_APP_APP_URL}/api/v1/loyality_cards/?token=${this.props.token}&phone_number=${res.phone}`)
        .then((r) => r.json())
        .then((body) => {
          if (!body.result.length) {
            this.setState({ loyality_balance: "Нет карты", loyality_card: null });
          } else {
            this.setState(
              { loyality_card: body.result[0], loyality_balance: body.result[0].balance.toFixed(2) },
              () => this.setFinishPrices(this.state.amount_with_discount)
            );
          }
        });
    });
  };

  findContract = (id) =>
    fetch(`https://${process.env.REACT_APP_APP_URL}/api/v1/contracts/${id || ""}/?token=${this.props.token}`)
      .then((r) => r.json());

  onSelectContract = (val) => {
    this.findContract(val).then((res) => {
      this.setState({ current_contract: res });
      this.formRef.current?.setFieldsValue({ contract: res.name });
    });
  };

  findOrg = (id) =>
    fetch(`https://${process.env.REACT_APP_APP_URL}/api/v1/organizations/${id}/?token=${this.props.token}`)
      .then((r) => r.json());

  onSelectOrg = (val) => {
    this.findOrg(val).then((res) => {
      this.setState({ current_organization: res });
      this.formRef.current?.setFieldsValue({ organization: res.short_name });
    });
  };

  findWareHouse = (id) =>
    fetch(`https://${process.env.REACT_APP_APP_URL}/api/v1/warehouses/${id}/?token=${this.props.token}`)
      .then((r) => r.json());

  onSelectWareHouse = (val) => {
    this.findWareHouse(val).then((res) => {
      this.setState({ current_warehouse: res });
      this.formRef.current?.setFieldsValue({ warehouse: res.name });
    });
  };

  findNomenclature = (id) =>
    fetch(`https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/${id}/?token=${this.props.token}`)
      .then((r) => r.json());

  handleDeleteNom = (id) => {
    const newData = [...this.state.nomDS];
    const index   = newData.findIndex((item) => id === item.id);
    if (index !== -1) {
      newData.splice(index, 1);
      this.setState({ nomDS: newData }, () => this.raschet(newData));
    }
  };

  onSelectNom = (val) => {
    this.setState({ current_nomenclature_price: null });
    this.findNomenclature(val).then((res) => {
      this.setState({ current_nomenclature: res, nomId: res.id });
      this.formRefNom.current.setFieldsValue({ nomenclature: res.name, chosen_nomenclature: res.name });

      if (res.type === "product") {
        if (!this.state.current_warehouse) {
          message.error("Вы не выбрали склад!");
        } else {
          fetch(`https://${process.env.REACT_APP_APP_URL}/api/v1/alt_warehouse_balances/?token=${this.props.token}&nomenclature_id=${res.id}&warehouse_id=${this.state.current_warehouse.id}`)
            .then((r) => r.json())
            .then((body) => {
              const hasStock = body.result.length > 0;
              this.formRefNom.current.setFieldsValue({ count: hasStock ? 1 : 0 });
              this.setState({ nomenclature_min: hasStock ? 1 : 0, nomenclature_max: hasStock ? body.result[0].current_amount : 0, addNomButtonDisabled: false });
            });
        }
      } else {
        this.formRefNom.current.setFieldsValue({ count: 1 });
        this.setState({ nomenclature_min: 1, nomenclature_max: null, addNomButtonDisabled: false });
      }

      axios.get(`https://${process.env.REACT_APP_APP_URL}/api/v1/alt_prices/${res.id}/`, {
        params: { token: this.props.token, price_type_id: this.state.selected_price_type },
      })
        .then((r) => this.setState({ current_nomenclature_price: r.data.price }))
        .catch((err) => this.setState({ current_nomenclature_price: err.response?.status === 404 ? 0 : null }));

      this.setState({ nomId: res.id }, () => { if (this.formRefNom.current) this.formRefNom.current.submit(); });
    });
  };

  changeCount = (val) => {
    const value   = this.formRefNom.current.getFieldValue("count");
    const nextVal = val === "plus" ? value + 1 : value - 1;
    if (nextVal >= 0) this.formRefNom.current.setFieldValue("count", nextVal);
  };

  changeDiscount = (val) => this.setState({ discount_type: val });

  addNomenclature = async (values) => {
    this.setState({ isRequestLoading: true });
    axios.get(`https://${process.env.REACT_APP_APP_URL}/api/v1/alt_prices/${this.state.nomId}`, {
      params: { token: this.props.token, price_type_id: this.state.selected_price_type },
    })
      .then((r) => {
        this.setState({ isRequestLoading: false });
        const count  = parseFloat(values.count);
        const price  = r.data.price || 0;
        const weight = this.state.current_nomenclature?.weight || 1000;

        let item = {
          id:           this.state.nomId,
          name:         values.nomenclature,
          amount:       this.state.current_nomenclature_price?.toFixed(2) || "0.00",
          discount:     0,
          count:        1,
          weight,                               // ← вес товара в граммах
          unit:         this.state.current_nomenclature.unit_name,
          final_amount: (price * count).toFixed(2),
        };

        if (values.discount > 0) {
          if (this.state.discount_type === "percent") {
            item.discount = ((parseFloat(item.amount) / 100) * values.discount).toFixed(2);
          } else {
            item.discount = values.discount.toFixed(2);
          }
          item.final_amount = (parseFloat(item.final_amount) - parseFloat(item.discount)).toFixed(2);
        }

        const DS    = [...this.state.nomDS];
        const index = DS.findIndex((i) => this.state.nomId === i.id);

        if (index !== -1) {
          const ex = DS[index];
          ex.count        = parseInt(ex.count + values.count);
          ex.final_amount = (parseFloat(ex.count) * parseFloat(ex.amount) - parseFloat(ex.discount)).toFixed(2);
          this.setState({ nomDS: DS, isRequestLoading: false }, () => this.raschet(DS));
        } else {
          DS.unshift(item);
          this.setState({ nomDS: DS, isRequestLoading: false }, () => this.raschet(DS));
        }
      })
      .catch((e) => {
        if (e.response?.status === 404) {
          const weight = this.state.current_nomenclature?.weight || 1000;
          let item = {
            id: this.state.nomId, name: values.nomenclature,
            amount: "0.00", discount: 0, count: 1, weight,
            unit: this.state.current_nomenclature.unit_name, final_amount: "0.00",
          };
          const DS    = [...this.state.nomDS];
          const index = DS.findIndex((i) => this.state.nomId === i.id);
          if (index !== -1) {
            DS[index].count = parseInt(DS[index].count + values.count);
            DS[index].final_amount = "0.00";
            this.setState({ nomDS: DS, isRequestLoading: false }, () => this.raschet(DS));
          } else {
            DS.unshift(item);
            this.setState({ nomDS: DS, isRequestLoading: false }, () => this.raschet(DS));
          }
        }
        this.setState({ isRequestLoading: false });
      });
  };

  requestOrganizations = async () => {
    await apiRequests.organizations.getItems().then((res) => {
      this.setState({ orgData: res.data.result.map((u) => ({ label: u.short_name, value: u.id })) });
    });
  };

  showModal = async () => {
    try {
      this.setState({ isLoading: true });
      const priceTypesRes = await apiRequests.priceTypes.getItems();
      const priceTypes = priceTypesRes.data.result.map((i) => ({ label: i.name, value: i.id }));
      this.setState({ price_types: priceTypes, selected_price_type: null });
      this.formRef.current?.setFieldsValue({ price_type: null });

      const res = await this.findDocSales(this.props.doc.id);
      this.formRef.current?.setFieldsValue({ priority: res.priority });

      const tagsArray = res.tags
        ? res.tags.split(",").map((t) => t.trim()).filter(Boolean)
        : [];
      this.formRef.current?.setFieldsValue({ tags: tagsArray });

      this.setState({ isInitialization: true, settings: res.settings, delivery_info: res.delivery_info });
      this.onSelectCa(res.contragent);
      this.onSelectContract(res.contract);
      this.onSelectWareHouse(res.warehouse);
      this.onSelectOrg(res.organization);

      // Собираем товары — добавляем поле weight если есть в good
      const nomDS = res.goods.map((g) => ({
        id:           g.nomenclature,
        name:         g.nomenclature_name,
        amount:       g.price.toFixed(2),
        discount:     g.discount,
        count:        g.quantity,
        weight:       g.weight || g.nomenclature_weight || 1000,  // ← берём вес из good если есть
        unit:         g.unit_name,
        final_amount: (parseFloat(g.price) * parseFloat(g.quantity)).toFixed(2),
      }));

      this.setState({ nomDS, current_organization: res.organization, isLoading: false }, () => {
        this.raschet(nomDS);
      });

      this.setState({ isModalVisible: true, initialTags: tagsArray });
    } catch (error) {
      console.error(error);
      this.setState({ isLoading: false });
    }
  };

  finish = () => {
    const { nomDS, date_next_created } = this.state;
    let body = {
      priority:    this.formRef.current.getFieldValue("priority") || 0,
      number:      this.formRef.current.getFieldValue("number"),
      dated:       Math.floor(Date.now() / 1000),
      operation:   "Заказ",
      comment:     this.formRef.current.getFieldValue("comment"),
      tax_included: true, tax_active: true,
      goods:       [],
      tags:        this.formRef.current.getFieldValue("tags"),
      settings: {
        ...this.formRefSettings.current?.getFieldsValue([
          "repeatability_period", "repeatability_value", "repeatability_count",
          "transfer_from_weekends", "skip_current_month", "default_payment_status",
          "repeatability_tags", "date_next_created", "repeatability_status",
        ]),
        date_next_created,
      },
    };

    if (Array.isArray(body.tags)) body.tags = body.tags.join(",");
    if (this.state.loyality_card) body.loyality_card_id = this.state.loyality_card.id;

    if (!this.state.current_warehouse || !this.state.current_organization)
      return message.error("Вы не выбрали склад или организацию!");

    body.warehouse = this.state.current_warehouse.id;
    if (this.state.current_contragent) body.contragent = this.state.current_contragent.id;
    if (this.state.current_contract)   body.contract   = this.state.current_contract.id;
    if (this.state.current_organization) body.organization = this.state.current_organization.id;

    nomDS.forEach((item) => {
      body.goods.push({
        price: parseFloat(item.amount), quantity: parseFloat(item.count),
        unit: 116, discount: parseFloat(item.discount),
        sum_discounted: parseFloat(item.discount), nomenclature: item.id,
      });
    });

    body.paid_rubles = this.finRef.current.getFieldValue("rubles");
    body.paid_lt     = this.finRef.current.getFieldValue("lt");
    body.id          = this.props.doc.id;

    apiRequests.docs.patchSales(this.props.doc.id, [body])
      .then(() => { message.success("Документ успешно изменён"); this.setState({ isModalVisible: false }); })
      .catch(() => {
        message.error(<span>Ошибка. <a href="https://t.me/tablecrmhelperpbot" target="_blank" rel="noopener noreferrer">Поддержка</a>.</span>, 3);
      });
  };

  onSaveLinks = async (data) => this.setState({ delivery_info: data });

  handleState = () => {
    this.setState({
      isModalVisible: false, isInitialization: false, current_contragent: null,
      changeData: false, discount_type: "percent", loyality_balance: 0,
      nomenclature_min: 0, nomenclature_max: 0, amount_without_discount: 0,
      amount_with_discount: 0, amount_discount: 0, nomDS: [], settings: {}, date_next_created: null,
    });
  };

  handleCancel = () => {
    this.state.changeData
      ? Modal.confirm({ title: "Подтвердите действие", content: "Вы действительно хотите закрыть окно?",
          okText: "Да", cancelText: "Нет", onOk: () => this.handleState() })
      : this.handleState();
  };

  onValuesChange = () => this.setState({ changeData: true });

  setFinishPrices = (total) => {
    if (this.state.loyality_card) {
      const bal   = this.state.loyality_card.balance;
      const max   = this.state.loyality_card.max_percentage;
      const avail = (bal / 100) * max;
      const diff  = total - avail;
      if (diff <= 0) {
        this.finRef.current?.setFieldValue("lt",     avail + diff);
        this.finRef.current?.setFieldValue("rubles", 0);
        this.setState({ max_paid_loyality: avail });
        return;
      }
      if (this.state.isInitialization) {
        this.finRef.current?.setFieldValue("lt",     this.props.doc.paid_loyality);
        this.finRef.current?.setFieldValue("rubles", this.props.doc.paid_rubles);
      } else {
        this.finRef.current?.setFieldValue("lt",     avail);
        this.finRef.current?.setFieldValue("rubles", diff);
      }
      this.setState({ max_paid_loyality: avail, isInitialization: false });
    }
  };

  onRecalculateLoyality = (value) => {
    if (this.state.loyality_card)
      this.finRef.current.setFieldValue("lt", Math.abs(this.state.amount_without_discount - value));
  };
  onRecalculateRubles = (value) => {
    this.finRef.current.setFieldValue("rubles", Math.abs(this.state.amount_without_discount - value));
  };

  createLoyalityCard = async () => {
    await apiRequests.loyalitySettings.getItems({ token: this.props.token, organization_id: this.state.current_organization.id })
      .then((res) => res.data.result[0])
      .then((org) => {
        if (!org) return;
        const body = {
          card_number: this.state.current_contragent.phone, tags: "",
          phone_number: this.state.current_contragent.phone,
          contragent_id: this.state.current_contragent.id, contragent_name: this.state.current_contragent.name,
          organization_id: this.state.current_organization.id, lifetime: org.lifetime,
          status_card: true, is_deleted: false,
        };
        apiRequests.loyalityCards.post([body]).then((r) => r.data[0].id).then((cardId) => {
          apiRequests.loyalityCards.getById(cardId).then((r) => {
            this.setState({ loyality_balance: r.data.balance.toFixed(2), loyality_card: r.data },
              () => this.setFinishPrices(this.state.amount_with_discount));
          });
        });
      });
  };

  handlePriceTypeChange = (value) => {
    this.setState({ selected_price_type: value }, () => this.updateAllNomenclaturePrices());
  };

  updateAllNomenclaturePrices = () => {
    const { nomDS, selected_price_type } = this.state;
    const token = this.props.token;
    const promises = nomDS.map((item) =>
      axios.get(`https://${process.env.REACT_APP_APP_URL}/api/v1/alt_prices/${item.id}`, { params: { token, price_type_id: selected_price_type } })
        .then((r) => {
          const price = r.data.price ? parseFloat(r.data.price) : 0;
          return { ...item, amount: price.toFixed(2), final_amount: (price * item.count - item.discount).toFixed(2) };
        })
        .catch((err) => err.response?.status === 404
          ? { ...item, amount: "0.00", final_amount: (0 - item.discount).toFixed(2) }
          : item)
    );
    Promise.all(promises).then((updated) => this.setState({ nomDS: updated }, () => this.raschet(updated)));
  };

  render() {
    const { nomDS } = this.state;
    const components = { body: { row: EditableRow, cell: EditableCell } };
    const columns = this.columns.map((col) =>
      !col.editable ? col : {
        ...col,
        onCell: (record) => ({ record, editable: col.editable, dataIndex: col.dataIndex, title: col.title, handleSave: this.handleSave }),
      }
    );

    return (
      <>
        <Button style={{ marginRight: 10 }} icon={<EditOutlined />} onClick={this.showModal} />
        <Modal
          width={1800} destroyOnClose footer={null} centered
          title={
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              Редактирование документа продажи
              <Button.Group>
                <Popover title="Настройки" trigger="click" content={
                  <Form name="basic" ref={this.formRefSettings} onValuesChange={this.onValuesChange} initialValues={this.state.settings}>
                    <div style={{ display: "flex", flexDirection: "row", gap: "4px" }}>
                      <Form.Item name="repeatability_period" style={{ flex: 2 }}>
                        <Select placeholder="Период" options={[
                          { value: "minutes", label: "Минуты" }, { value: "hours", label: "Часы" },
                          { value: "days", label: "Дни" }, { value: "weeks", label: "Недели" }, { value: "months", label: "Месяцы" },
                        ]} />
                      </Form.Item>
                      <Form.Item name="repeatability_value" style={{ flex: 1 }}><Input type="number" placeholder="value" /></Form.Item>
                      <Form.Item name="repeatability_count" style={{ flex: 1 }}><Input type="number" placeholder="count" /></Form.Item>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ textAlign: "end" }}>
                          <Form.Item label="Переносить с выходных" name="transfer_from_weekends" valuePropName="checked" style={{ margin: 0 }}><Checkbox /></Form.Item>
                          <Form.Item label="Пропустить текущий месяц" name="skip_current_month" valuePropName="checked" style={{ margin: 0 }}><Checkbox /></Form.Item>
                        </div>
                        <div style={{ textAlign: "end" }}>
                          <Form.Item label="Проводить платежи" name="default_payment_status" valuePropName="checked" style={{ margin: 0 }}><Checkbox /></Form.Item>
                          <Form.Item label="Повторить теги" name="repeatability_tags" valuePropName="checked" style={{ margin: 0 }}><Checkbox /></Form.Item>
                        </div>
                      </div>
                      <Form.Item label="Включить автоповтор" name="repeatability_status" valuePropName="checked" style={{ margin: "24px 0 0 0" }}><Checkbox /></Form.Item>
                      <Form.Item name="date_next_created" style={{ margin: "24px 0 0 0" }}>
                        <DatePicker style={{ width: "100%" }} placeholder="Следующее создание"
                          onChange={(date) => this.setState({ date_next_created: date.unix() })} />
                      </Form.Item>
                    </div>
                  </Form>
                }>
                  <Button><SettingOutlined /></Button>
                </Popover>
                <Button onClick={this.handleCancel}><CloseOutlined /></Button>
              </Button.Group>
            </div>
          }
          closeIcon={null}
          open={this.state.isModalVisible}
          onCancel={this.handleCancel}
        >
          <AddBarCode visible={this.state.isAddBarCodeVisible} close={this.closeAddBarcode} barcode={this.state.barcode} api={this.api} token={this.props.token} />
          <BarcodeReader onScan={this.barcodeFind} />
          <Layout>
            <Sider style={siderStyle}>
              <Form name="basic" ref={this.formRef} layout="vertical"
                style={{ marginLeft: 10, marginRight: 10 }}
                initialValues={{ ...this.leftBarIV, tags: this.state.initialTags }}
                onValuesChange={this.onValuesChange}>
                <Form.Item label="Контрагент" name="contragent" style={{ marginBottom: 12 }}>
                  <ContragentAutocomplete forType="docs_sales" contragent={this.state.current_contragent}
                    api={this.api} token={this.props.token} warehouse={this.state.current_warehouse}
                    onSelect={this.onSelectCa} width={180} />
                  <div style={this.state.current_contragent ? { display: "flex", marginTop: 8 } : { display: "none" }}>
                    <ContragentTags contragent={this.state.current_contragent} />
                  </div>
                </Form.Item>
                <Form.Item label="Склад отгрузки" name="warehouse" style={{ marginBottom: 12 }}>
                  {this.state.isLoading === false && this.state.current_warehouse
                    ? <WareHousesAutocomplete api={this.api} token={this.props.token} value={this.state.current_warehouse} onSelect={this.onSelectWareHouse} nodefaultvalue={false} />
                    : <SkeletonInput />}
                </Form.Item>
                <Form.Item label="Организация" name="organization" style={{ marginBottom: 12 }}>
                  {this.state.isLoading === false && this.state.current_organization
                    ? <OrganizationAutoComplete api={this.api} token={this.props.token} value={this.state.current_organization} onSelect={this.onSelectOrg} nodefaultvalue={false} />
                    : <SkeletonInput />}
                </Form.Item>
                <Form.Item label="Приоритет" name="priority" style={{ marginBottom: 12 }} initialValue={this.props.doc.priority}>
                  <InputNumber min={0} max={10} style={{ width: "100%" }} placeholder="0-10" />
                </Form.Item>
                <Form.Item label="Тип цены" name="price_type">
                  <Select value={this.state.selected_price_type} options={this.state.price_types}
                    onChange={this.handlePriceTypeChange} placeholder="Выберите тип цены" />
                </Form.Item>
              </Form>
              <div style={{ marginLeft: 10, marginRight: 10 }}>
                <DocsSalesOrderDrawer
                  deliveryInfo={this.state.delivery_info}
                  docId={this.props.doc.id}
                  onSave={this.onSaveLinks}
                  items={this.state.nomDS}
                  warehouse={this.state.current_warehouse}
                  recipient={this.state.current_contragent}
                  token={this.props.token}
                  onCdekOrderCreated={() => {}}
                />
              </div>
            </Sider>
            <Layout>
              <Header style={headerStyle}>
                <Form name="basic1" ref={this.formRefNom} style={{ display: "flex" }} layout="inline"
                  initialValues={{ remember: true }} onValuesChange={this.onValuesChange} onFinish={this.addNomenclature}>
                  <Compact style={{ width: "100%" }}>
                    <Form.Item style={{ width: "10%", marginInlineEnd: 0 }} name="nomenclature">
                      <NomenclatureAutoComplete buttonIntegrated placeholder="Выберите товар"
                        api={this.api} token={this.props.token} onSelect={this.onSelectNom} />
                    </Form.Item>
                    <Form.Item name="name_nomeclature" style={{ width: "90%", marginInlineEnd: 0 }}>
                      <NomenclatureSearchField api={this.api} token={this.props.token}
                        select={this.onSelectNom} nomDS={this.state.nomDS} />
                    </Form.Item>
                  </Compact>
                  <Form.Item name="count" initialValue={1} hidden>
                    <InputNumber precision={0} min={0} />
                  </Form.Item>
                </Form>
              </Header>
              <Content style={contentStyle}>
                <Table style={{ marginTop: 10 }}
                  dataSource={require("lodash").cloneDeep(nomDS)}
                  components={components} rowClassName={(r) => r.is_deleted && "disabled-row"}
                  rowKey={(r) => r.id} bordered columns={columns} />
              </Content>
            </Layout>
            <Sider style={siderStyle}>
              <Form name="basic2" ref={this.finRef} layout="vertical" style={{ marginLeft: 10, marginRight: 10 }}>
                <Form.Item label="Без скидки:" style={{ marginBottom: 12 }}>
                  <Input style={{ color: "black" }} disabled value={this.state.amount_without_discount} />
                </Form.Item>
                <Form.Item label="Скидка:" style={{ marginBottom: 12 }}>
                  <Input style={{ color: "black" }} disabled value={this.state.amount_discount} />
                </Form.Item>
                <Form.Item label="Остаток лояльности:" style={{ marginBottom: 12 }}>
                  <Input
                    style={
                      !this.state.loyality_balance ? { color: "orange", borderColor: "orange" } :
                      this.state.loyality_balance === "Нет карты" ? { color: "red", borderColor: "red" } :
                      Number(this.state.loyality_balance) === 0 ? { color: "green", borderColor: "green" } :
                      { color: "blue", borderColor: "blue" }
                    }
                    disabled
                    value={
                      !this.state.loyality_balance ? "Не выбран контрагент!" :
                      this.state.loyality_balance === "Нет карты" ? this.state.loyality_balance :
                      Number(this.state.loyality_balance) === 0 ? "Нет баллов" :
                      this.state.loyality_balance
                    }
                  />
                  {this.state.loyality_balance === "Нет карты" && (
                    <Button onClick={this.createLoyalityCard} style={{ width: "100%", marginTop: 10 }}>Создать карту</Button>
                  )}
                </Form.Item>
                <Form.Item label="Итого:" style={{ marginBottom: 12 }}>
                  <Input style={{ color: "black" }} disabled value={this.state.amount_with_discount} />
                </Form.Item>
                <Form.Item label="Баллами:" name="lt" initialValue={this.props.doc.paid_loyality} style={{ marginBottom: 12 }}>
                  <InputNumber style={{ width: "100%" }} precision={2} min={0}
                    max={this.state.max_paid_loyality} disabled={!this.state.loyality_card}
                    controls={false} onChange={(v) => this.onRecalculateRubles(v)} />
                </Form.Item>
                <Form.Item label="Рублями:" name="rubles" initialValue={this.props.doc.paid_rubles}>
                  <InputNumber style={{ width: "100%" }} precision={2} min={0}
                    max={this.state.amount_with_discount} controls={false}
                    onChange={(v) => this.onRecalculateLoyality(v)} />
                </Form.Item>
              </Form>
              <Button onClick={() => this.finish()} style={{ width: "100%" }}>Изменить</Button>
            </Sider>
          </Layout>
        </Modal>
      </>
    );
  }
}

export default EditDocsSales;